import React from 'react';
import { Modal} from 'react-bootstrap';
import './modalVideos.css'
import { HtmlViewer } from '../../htmlViewer/HtmlViewer'

export const ModalVideos = ({ showModal, toggleModal,info, description }) => {



    return (
        <>


            <Modal show={showModal} onHide={toggleModal} dialogClassName='modal-dialog-centered classModelDialog2'>
                <Modal.Header closeButton>
                    <Modal.Title>
                        <p>Info</p>
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body className='ModalBodyStyle2'>

                <i className="bi bi-info-circle-fill bi-class-info"><h4>{info}</h4></i>
                {description?.indexOf("%3C") < 0 ? <p>{description}</p> : <HtmlViewer content={decodeURIComponent(description)}></HtmlViewer>}                
                    {/* <FloatingLabel
                        controlId="floatingInput"
                        label="Email "
                        className="mb-3"
                    >
                        <Form.Control type="email" placeholder="name@example.com" />
                    </FloatingLabel> */}

                </Modal.Body>

                {/* <Modal.Footer className='footerClass'>
                    <Button className='button' variant="secondary" onClick={toggleModal}>

                    </Button>

                </Modal.Footer> */}
            </Modal>
        </>
    );
};


